import React from "react"
import { Slider } from "@/components/ui/slider"

export type RangeSliderComponentType = {
  originAtCenter?: boolean
  generateLabels?: boolean
  min?: number
  max?: number
  value: number
  changeValue: (val: number) => void
  step?: number
}

const RangeSlider: React.FC<RangeSliderComponentType> = ({
  originAtCenter = false,
  generateLabels: _generateLabels = false,
  min = 0,
  max = 10,
  value,
  changeValue,
  step: providedStep,
}) => {
  const clampedValue = Math.max(min, Math.min(max, value))
  const range = max - min
  const defaultStep = range < 3 ? 0.01 : range < 10 ? 0.1 : range < 100 ? 1 : 10
  const step = providedStep ?? (originAtCenter ? defaultStep : 0.1)

  return (
    <div className="white-slider w-full">
      <Slider
        value={[clampedValue]}
        min={min}
        max={max}
        step={step}
        onValueChange={(values) => {
          const newValue = values[0]
          if (typeof newValue === "number" && !isNaN(newValue)) changeValue(newValue)
        }}
        className="w-full"
      />
    </div>
  )
}

export default RangeSlider
